const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});
import { post } from '../../../util/api';

export const getSubscriptions = (setIsStripeConnected, setSubscriptions) => {
  sdk.currentUser
    .show({
      include: ['stripeAccount', 'stripeCustomer'],
    })
    .then(resp => {
      const isConnected = resp.data.data.attributes.stripeConnected;
      const userEmail = resp.data.data.attributes.email;
      const userId = resp.data.data.id.uuid;
      const hasCustomerId = resp.data.data.attributes.profile.privateData
        ? resp.data.data.attributes.profile.privateData.stripeCustomerId
          ? resp.data.data.attributes.profile.privateData.stripeCustomerId
          : null
        : null;
      setIsStripeConnected(isConnected);
      return [hasCustomerId, userEmail, userId];
    })
    .then(resp => {
      const stripeCustomerId = resp[0];
      const userEmail = resp[1];
      const userId = resp[2];

      if (stripeCustomerId) {
        const requestOptions = {
          stripeCustomerId: stripeCustomerId,
        };

        const fetchData = async () => {
          const { subscriptions } = await post('/api/subscriptions-list', requestOptions);

          setSubscriptions(subscriptions.data);
        };
        fetchData();
      } else {
        post('/api/create-customer', {
          email: userEmail,
          userId: userId,
        }).catch(error => console.log(error));

        setSubscriptions([]);
      }
    })
    .catch(e => console.log(e));
};
